/** Opens Google search for Raheasy (footer badge + floating review popup). */
export const GOOGLE_REVIEWS_SEARCH_URL =
  'https://www.google.com/search?q=raheasy&oq=raheasy&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIICAEQRRgnGDsyBggCEEUYOzIHCAMQABjvBTIHCAQQABjvBTIHCAUQABjvBTIHCAYQABjvBTIHCAcQABjvBdIBCTUxMzVqMGoxNagCCLACAfEFrnN004i6lTo&sourceid=chrome&ie=UTF-8';
